@if (pageRendererComponent$ | async) {
  <ng-container [ngComponentOutlet]="pageRendererComponent$ | async" />
}
